import { UNIVERSITY_OFFER } from '../../../'
import React from 'react'

export interface MsgBoxProps {
    modifier?: string
    isEmailVerified?: boolean
    messageType?: string
}

export function InfoMessageBox(props: MsgBoxProps) {
    const { modifier, isEmailVerified, messageType } = props

    return (
        <>
            {modifier && (
                <>
                    {!isEmailVerified && typeof messageType == 'undefined' && (
                        <p>
                            {modifier === UNIVERSITY_OFFER
                                ? 'Thank you for providing your valid student email address. Check your inbox (or junk) for your verification email.'
                                : 'Thank you. We have just sent you an email. Please verify your email and continue subscribing.'}
                        </p>
                    )}
                    {isEmailVerified && (
                        <p>
                            Thank you for verifying your email. Please click the
                            button below to finish your Subscription with
                            Google.
                        </p>
                    )}

                    {messageType == 'TokenExpired' && (
                        <p>
                            Oops! It seems there may have been a problem with
                            verifying your email. Or the link has expired.
                            Please try verifying your email again.
                        </p>
                    )}
                </>
            )}
        </>
    )
}

export default InfoMessageBox
